import React, { useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import CartFooter from '../../common/CartFooter';
import { HiPlus, HiMinus } from 'react-icons/hi';

function FindOrder() {

    return(
        <>
          <div className="containernn">
             <div className="cart-wrap alt">
                <div className="appoint-details">
                   <div className='row justify-content-center'>
                     <div className='col-lg-6'>
                        <h2 className='title'>appointment details</h2>
                        <div className="inp-wrap">
                            <label htmlFor="">Order ID</label>
                            <input className="inp" type="text" placeholder="12312423423" />
                        </div>
                        <h2 className='title mt-5'>Patient e-mail</h2>
                        <div className="inp-wrap">
                            <label htmlFor="">Order ID</label>
                            <input className="inp" type="text" placeholder="email@email.com" />
                        </div>
                        <div className="inp-wrap">
                            <label htmlFor="">Patient Zip/ Post code</label>
                            <input className="inp" type="text" placeholder="W12 9NN" />
                        </div>
                        <div className='inp-wrap text-center'>
                            <Link to="/re-appointment" className='themeBtn'>Find appointment</Link>
                        </div>
                        <div className="d-flex align-items-center justify-content-center warnMsg mt-4">
                            <img alt="" src={require('../../images/icons/warning.png')} />
                            <p>No appointment match with the above details</p>
                        </div>
                     </div>
                   </div>
                </div>
             </div>
          </div>

          <div className="cart-footer">
              <CartFooter/>
          </div>


        </>
    )
}

export default FindOrder;